<template>
  <div>
    <b-row>
      <b-col sm="12" md="6">
        <b-card no-body v-if="mostrarSemAct">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemAct = false"
                      id="btn_back"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_act.length}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0">
            <b-row>
              <b-col sm="2" class=" align-self-center" style="margin-top:-22px; margin-bottom: -18px">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      id="act_semAct"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                      @click="obtenerHistorialCosechadores"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <!-- <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion')"
                      @click="mostrarModalImportar(true)"
                      id="imp_semAct"
                      :disabled="loadingSAM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button> -->
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="descargarRegistros"
                      :disabled="loading2"
                      id="btn_descargar_registros"
                      v-b-tooltip.hover="'Descargar Excel'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>

                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="descargarPdf"
                      :disabled="loading3"
                      id="btn_descargar_pdf"
                      v-b-tooltip.hover="'Descargar Pdf'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-pdf"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <!-- <b-col md="2"></b-col> -->
              <b-col sm="3" class=" align-self-center" style="margin-bottom: -18px">

                <b-form-group
                    label="Fecha de Inicio"
                    label-for="fecha_inicio"
                >
                  <b-form-datepicker
                      id="fecha_inicio"
                      v-model="fecha_inicio"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      :hide-header=true
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      size="sm"
                      close-button
                      name="fecha_inicio"
                      placeholder="Fecha de Inicio"
                      @input="obtenerHistorialCosechadores"
                  />
                </b-form-group>

                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;"></span><br>

              </b-col>

              <b-col sm="3" class=" align-self-center" style="margin-bottom: -18px">

                <b-form-group
                    label="Fecha Fin"
                    label-for="fecha_fin"
                >
                  <b-form-datepicker
                      id="fecha_fin"
                      v-model="fecha_fin"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      :hide-header=true
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      size="sm"
                      close-button
                      name="fecha_fin"
                      placeholder="Fecha Fin"
                      @input="obtenerHistorialCosechadores"
                  />
                </b-form-group>

                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;"></span><br>

              </b-col>

              <b-col sm="4" class=" align-self-center" style="margin-top:-28px; margin-bottom: -18px">
                <b-form-group
                    label="Buscar por:"
                    label-for="evento"
                >
                  <b-input-group size="md">
                    <b-form-input
                        id="evento"
                        v-model="evento"
                        name="evento"
                        size="sm"
                    />
                    <b-input-group-append>
                      <b-button
                          variant="gradient-secondary"
                          :disabled="!evento"
                          @click="itemsFiltro = items; evento = ''"
                          size="sm"
                      >
                        Borrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- TABLA DE ENTREGA -->
          <b-table
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="evento"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <!-- <template #cell(acciones)="data">
              <div class="text-nowrap">

                <feather-icon
                    v-if="$can('read', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalle(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template> -->

            <template #cell(estado)="data">
              <b-badge :variant="status_uno[1][parseInt(data.value)]">
                {{ status_uno[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(accion)="data">
              <b-badge :variant="status_dos[1][data.value]">
                {{ status_dos[0][data.value] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
            <span>
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  localeMatcher: 'best fit',
                  hour: '2-digit',
                  minute: '2-digit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
            </template>
          </b-table>
          <b-col sm="12"  align="center" style="margin-top:-10px; margin-bottom:5px;">
            <span class="font-weight-bolder font-small-4" style=" vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registros - Total: ${this.items.length}` }}</span>
          </b-col>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <!-- <b-card no-body>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemSgte = false"
                      id="btn_backSgte"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_sgte.length}` }}</span>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>  -->

        <!-- Grafico Lineal -->
        <b-card no-body>
          <b-card-body class="px-1 pb-0 pt-4 contenedor_grafico">
            <h4 style="text-align:center; margin-top:25px; margin-bottom:40px;">Promedio de Experiencia Semanal</h4>
            <div class="grafico_lineal" id="chartdiv" ref="chartdiv"></div>
            <div class="ocultador"></div>
            <!-- <b-card title="">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-content-center mb-1 mb-sm-0">
                </div>
              </div>

              <app-echart-line :option-data="opcioness" ref="graf_lin" style="20px"/>

            </b-card> -->
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

    <!-- Formulario para Registrar lo que se le entrega al trabajador -->
    <!-- FORMULARIO DE ENTREGA -->
    <b-modal
        id="modal-prevent-closing"
        modal-class="align-right-modal"
        v-model="modal_registro_entrega"
        title="Registro Entrega de Indumentaria al Trabajador"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="lg"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok=""
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEntrega" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="registrarEntrega">
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="DNI"
                  label-for="dni"
              >
                <validation-provider
                    #default="{ errors }"
                    name="dni"
                    vid="dni"
                    rules="required|integer|between:1,99999999"
                >
                  <b-form-input
                      id="dni"
                      v-model="dni"
                      :state="errors.length > 0 ? false:null"
                      name="dni"
                      ref="dniInput"
                      @input="buscarUbicacionIndumentaria"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="CODIGO COLGADOR"
                  label-for="cod_asociado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cod_asociado"
                    vid="cod_asociado"
                    rules="required"
                >
                  <b-form-input
                      id="cod_asociado"
                      v-model="cod_asociado"
                      :state="errors.length > 0 ? false:null"
                      name="cod_asociado"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="INDUMENTARIAS: 2"
                  label-for="indumentaria"
              >
                <validation-provider
                    #default="{ errors }"
                    name="indumentaria"
                    vid="indumentaria"
                    rules="required"
                >
                  <v-select
                      id="indumentaria"
                      v-model="indumentaria"
                      :options="indumentarias"
                      label="text"
                      key="value"
                      placeholder="Selecciona indumentaria..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="ESTADO"
                  label-for="estado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estado"
                    vid="estado"
                    rules="required"
                >
                  <v-select
                      id="estado"
                      v-model="estado"
                      :options="estados"
                      label="text"
                      key="value"
                      placeholder="Selecciona estado..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="8">
              <b-form-group
                  label="NOMBRES"
                  label-for="nombres"
              >
                <validation-provider
                    #default="{ errors }"
                    name="nombres"
                    vid="nombres"
                    rules="required"
                >
                  <b-form-input
                      id="nombres"
                      v-model="nombres"
                      :state="errors.length > 0 ? false:null"
                      name="nombres"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="CARGO"
                  label-for="cargo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cargo"
                    vid="cargo"
                    rules="required"
                >
                  <b-form-input
                      id="cargo"
                      v-model="cargo"
                      :state="errors.length > 0 ? false:null"
                      name="cargo"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="OBSERVACIONES DE ENTREGA"
                  label-for="observaciones"
              >
                <validation-provider
                    #default="{ errors }"
                    name="observaciones"
                    vid="observaciones"
                    rules="required"
                >
                  <b-form-textarea
                      id="observaciones"
                      v-model="observaciones"
                      :state="errors.length > 0 ? false:null"
                      name="observaciones"
                      style="height:100px;max-height:100px"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Formulario para Registrar lo que el trabajador entrega a la Estación -->
    <!-- FORMULARIO DE RECEPCION -->
    <b-modal
        modal-class="align-left-modal"
        v-model="modal_registro_devolucion"
        ref="my-modal"
        title="Registro Recepcion de Indumentaria del Trabajador"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="lg"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok=""
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioRecepcion" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="registrarRecepcion">
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="DNI"
                  label-for="dni_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="dni_dos"
                    vid="dni_dos"
                    rules="required|integer|between:1,99999999"
                >
                  <b-form-input
                      id="dni_dos"
                      v-model="dni_dos"
                      :state="errors.length > 0 ? false:null"
                      name="dni_dos"
                      @input="buscarTrabajadorPorDni(true)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="CODIGO COLGADOR"
                  label-for="cod_asociado_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cod_asociado_dos"
                    vid="cod_asociado_dos"
                    rules="required"
                >
                  <b-form-input
                      id="cod_asociado_dos"
                      v-model="cod_asociado_dos"
                      :state="errors.length > 0 ? false:null"
                      name="cod_asociado_dos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="INDUMENTARIA"
                  label-for="indumentaria"
              >
                <validation-provider
                    #default="{ errors }"
                    name="indumentaria"
                    vid="indumentaria"
                    rules="required"
                >
                  <v-select
                      id="indumentaria"
                      v-model="indumentaria_dos"
                      :options="indumentarias"
                      label="text"
                      key="value"
                      placeholder="Selecciona indumentaria..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="ESTADO"
                  label-for="estado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estado"
                    vid="estado"
                    rules="required"
                >
                  <v-select
                      id="estado"
                      v-model="estado_dos"
                      :options="estados"
                      label="text"
                      key="value"
                      placeholder="Selecciona estado..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="8">
              <b-form-group
                  label="NOMBRES"
                  label-for="nombres_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="nombres_dos"
                    vid="nombres_dos"
                    rules="required"
                >
                  <b-form-input
                      id="nombres_dos"
                      v-model="nombres_dos"
                      :state="errors.length > 0 ? false:null"
                      name="nombres_dos"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="CARGO"
                  label-for="cargo_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cargo_dos"
                    vid="cargo_dos"
                    rules="required"
                >
                  <b-form-input
                      id="cargo_dos"
                      v-model="cargo_dos"
                      :state="errors.length > 0 ? false:null"
                      name="cargo_dos"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="OBSERVACIONES DE RECEPCION"
                  label-for="observaciones_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="observaciones_dos"
                    vid="observaciones_dos"
                    rules="required"
                >
                  <b-form-textarea
                      id="observaciones_dos"
                      v-model="observaciones_dos"
                      :state="errors.length > 0 ? false:null"
                      name="observaciones_dos"
                      style="height:100px;max-height:100px"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingIMP"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="estadoModalRespuesta"
        title="Respuesta"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <!-- <span>Se realizaron la creación de {{ respuestaRegistrosTotal }} registros satisfactoriamente.</span><br><br>
          <span>Se encontraron {{ respuestaErrores.length }} registros con errores:</span><br><br> -->
          <span>Se realizó la creación de registros satisfactoriamente.</span>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modal-seleccionar-estacion"
        ref="modal-seleccionar-estacion"
        v-model="estadoModalEstacion"
        title="Apertura de Estación"
        ok-title="Guardar"
        ok-only
        size="sm"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-close-button
        :ok-disabled="!loadingEST"
        @show=""
        @hidden=""
    >
      <b-row>
        <b-col lg="12">
          <validation-provider
              #default="{ errors }"
              name="Estacion"
              vid="estacion"
              rules="required"
          >
            <v-select
                id="estacion"
                v-model="estacion"
                :options="estaciones"
                :reduce="estaciones => estaciones.value"
                label="text"
                key="value"
                placeholder="Por favor seleccionar la estación de trabajo"
                class="mb-9 mt-1"
                @input="actualizarEstacion"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <br>
        </b-col>
      </b-row>
    </b-modal>

    <!-- --------------MODAL EDITAR--------i -->
    <b-modal
        id="modal-select2"
        v-model="modalEditarEstadoShow"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Actualizar"
        :ok-disabled="!estado_aprobar"
        cancel-title="Cancelar"
        centered
        title="Autorizar registro"
        @ok=""
    >
      <b-form>
        <b-form-group
            label="Estado"
            label-for="estado_editar"
        >
          <v-select
              id="estado_editar"
              v-model="estado_aprobar"
              :options="estados"
              :reduce="estados => estados.value"
              label="text"
              key="value"
              placeholder="Seleccionar estado..."
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BFormDatepicker,
  BFormTimepicker,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
  BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

let digitos_fecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
let fecha_hoy=new Date()
//Formateo fecha_hoy
let fecha_actual = fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_actual=fecha_actual[2]+'-'+fecha_actual[1]+'-'+fecha_actual[0]

export default {
  components: {
    BCard,
    AppEchartLine,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BFormDatepicker,
    BFormTimepicker,
    BButtonGroup,
    BAlert,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,

    dias: null,
    // fecha_inicio:'2023-02-13',
    // fecha_inicio:'2023-02-20',
    // fecha_fin:fecha_actual,
    fecha_inicio:'',
    fecha_fin:'',
    conta:0,
    promedios:[],
    evento:'',
    labels:'',
    name:'HolaMundo',
    root_grafico: null,

    opcioness: {
      xAxisData:[],
      series: []
      // xAxisData: ['7/12', '8/12', '9/12', '10/12', '11/12', '12/12', '13/12', '14/12', '15/12', '16/12', '17/12', '18/12', '19/12', '20/12', '18/12', '19/12', '20/12'],
      // series: ['290', '200', '210', '190', '250', '220', '80', '90', '200', '150', '160', '100', '140', '100', '30', '140', '100', '30' ],
      // xAxisData:['2023-10', '2023-9'],
      // series:['1.61', '3.77']
    },

    modal_registro_entrega: false,
    modal_registro_devolucion: false,
    loadingEST: false,

    submittedNames: [],
    loading: false,
    loading2: false,
    loading3:false,
    loadingBP: false,
    loadingDE: false,
    loadingIMP: false,
    loadingEDI: false,

    loadingSAC: false,
    loadingSSC: false,
    loadingSSM: false,
    loadingSAM: false,
    loadingSAD: false,
    loadingSSD: false,

    estadoModalEditar: false,
    estadoModalImportar: false,
    estadoModalEstacion:false,
    estadoModalRespuesta: false,

    modalEditarEstadoShow: false,
    items: [],
    items_completo: [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['accion'],
    fields: [

      // {
      //   key: 'acciones',
      //   label: '# ',
      //   class: 'text-nowrap text-center',
      //   stickyColumn: true,
      // },
      // {
      //   key: 'index',
      //   label: '#',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      //   formatter: (value, { index }) => {
      //     // Calcula el número de registro sumando 1 al índice
      //     return (index + 1).toString();
      //   },
      // },
      {
        key: 'year_week',
        label: 'SEMANA',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dni',
        label: 'DNI',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'nombres',
        label: 'NOMBRES',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'sum_dias_week',
        // label: 'HISTORICO DE DIAS LABORADOS',
        label: 'HIST. DIAS LABORADOS',
        class: 'text-nowrap text-center',
        sortable: true,
      },


    ],

    espanol:{
      labelNoTimeSelected: 'Seleccione Hora',
    },

    status_uno: [
      // {
      //   0: 'Pendiente',
      //   1: 'Revisado',
      //   2: 'Aprobado',
      //   3: 'Desaprobado',
      //   4: 'Eliminado',
      // },
      // {
      //   0: 'light-info',
      //   1: 'light-warning',
      //   2: 'light-success',
      //   3: 'light-danger',
      //   4: 'light-dark',
      // }
      {
        0: 'Pendiente',
        1: 'Atendido',
        2: 'Aprobado',
        3: 'Desaprobado',
        4: 'Eliminado',
      },
      {
        0: 'light-info',
        1: 'light-success',
        2: 'light-warning',
        3: 'light-danger',
        4: 'light-dark',
      },

    ],

    status_dos: [
      {
        'E': 'Entregado',
        'R': 'Recepcionado',
      },
      {
        'E': 'light-danger',
        'R': 'light-warning',
      }
    ],


    estados: [
      {value: '0', text: "Pendiente"},
      {value: '1', text: "Atendido"},
      /*
      {value: '1', text: "Observar"},
      {value: '3', text: "Desaprobar"}
       */
    ],

    parametros_usuario: [],

    estado_aprobar: null,

    archivo_excel: null,
    empresas: [],
    cultivos: [],
    cultivosIMP: ['ARANDANO', 'ESPÁRRAGO', 'PALTA', 'UVA'],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    codigos_h: [],
    parametros: [],

    dataEmpresa: [],
    dataLotesValvulas: [],
    notDuplicados: [],
    dataCompleta: [],

    spd: [],
    dia: null,
    hora: null,
    // -------

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    dataAutorizar:null,

    semanaActual: true,
    semanaEnviar: null,

    mostrarAlert: false,
    mostrarAlert2: false,

    respuestaRegistrosTotal: 0,
    respuestaErrores: [],

    // validation rules
    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {},
  async mounted() {
    this.root_grafico=am5.Root.new("chartdiv");
    this.obtenerHistorialCosechadores()

    localize("es");

  },

  methods: {

    dibujarGrafico(){

      const yo=this;
      console.log("DIBUJANDO EL GRAFICO...")
      console.log(yo.promedios)

      yo.root_grafico.container.children.clear();
      // yo.root_grafico.dispose();

      am5.ready(function() {

        var data=[];
        var data = yo.promedios

        console.log("Imprimiendo data")
        console.log(data)

        // var data = [
        //   {
        //     country: "USA",
        //     visits: 3025,

        //   },
        //   {
        //     country: "China",
        //     visits: 1882,

        //   },
        //   {
        //     country: "Japan",
        //     visits: 1809,

        //   },
        //   {
        //     country: "Germany",
        //     visits: 1322,

        //   },
        //   {
        //     country: "UK",
        //     visits: 1122,

        //   },
        //   {
        //     country: "France",
        //     visits: 1114,

        //   },
        //   {
        //     country: "India",
        //     visits: 984,

        //   }
        // ];

        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        // var root = am5.Root.new("chartdiv");

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        yo.root_grafico.setThemes([
          am5themes_Animated.new(yo.root_grafico)
        ]);

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        var chart = yo.root_grafico.container.children.push(
            am5xy.XYChart.new(yo.root_grafico, {
              panX: true,
              panY: true,
              wheelY: "zoomXY",
              pinchZoomX: true
            })
        );

        chart.get("colors").set("step", 2);

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/

        var xRenderer = am5xy.AxisRendererX.new(yo.root_grafico, {
          minGridDistance: 50
        });


        var xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(yo.root_grafico, {
              categoryField: "country",
              renderer: xRenderer,
              // tooltip: am5.Tooltip.new(yo.root_grafico, {})
            })
        );

        xRenderer.grid.template.setAll({
          location: 1
        })

        var yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(yo.root_grafico, {
              extraMax: 0.1,
              extraMin: 0.1,
              renderer: am5xy.AxisRendererY.new(yo.root_grafico, {
                strokeOpacity: 0.1
              }),
              // tooltip: am5.Tooltip.new(yo.root_grafico, {})
            })
        );

        // Create series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        var series = chart.series.push(
            am5xy.LineSeries.new(yo.root_grafico, {
              calculateAggregates: true,
              xAxis: xAxis,
              yAxis: yAxis,
              valueYField: "visits",
              categoryXField: "country",
              // tooltip: am5.Tooltip.new(yo.root_grafico, {
              //   labelText: "Promedio: {valueY}"
              // })
            })
        );

        // add error bullet
        series.bullets.push(function() {
          var graphics = am5.Graphics.new(yo.root_grafico, {
            strokeWidth: 2,
            stroke: series.get("stroke"),
            draw: function(display, target) {
              var dataItem = target.dataItem;

              var error = dataItem.dataContext.error;

              var yPosition0 = yAxis.valueToPosition(0);
              var yPosition1 = yAxis.valueToPosition(error);

              var height =
                  (yAxis.get("renderer").positionToCoordinate(yPosition1) - yAxis.get("renderer").positionToCoordinate(yPosition0)) / 2;

              display.moveTo(0, -height);
              display.lineTo(0, height);

              display.moveTo(-10, -height);
              display.lineTo(10, -height);

              display.moveTo(-10, height);
              display.lineTo(10, height);
            }
          });

          return am5.Bullet.new(yo.root_grafico, {
            dynamic: true,
            sprite: graphics
          });
        });

        // Add circle bullet
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/#Bullets
        // series.bullets.push(function() {
        //   var graphics = am5.Circle.new(yo.root_grafico, {
        //     strokeWidth: 2,
        //     radius: 5,
        //     stroke: series.get("stroke"),
        //     fill: yo.root_grafico.interfaceColors.get("background")
        //   });
        //   return am5.Bullet.new(yo.root_grafico, {
        //     sprite: graphics
        //   });
        // });


        series.bullets.push(function() {
          var container = am5.Container.new(yo.root_grafico, {
            centerX: am5.p50,
            centerY: am5.p50
          });

          container.children.push(
              am5.Circle.new(yo.root_grafico, { radius: 9, fill: series.get("fill") })
          );

          container.children.push(
              am5.Label.new(yo.root_grafico, {
                text: "{visits}",
                fill: yo.root_grafico.interfaceColors.get("black"),
                centerY: 0,
                centerX: am5.p50,
                populateText: true,
              })
          );

          return am5.Bullet.new(yo.root_grafico, {
            sprite: container
          });
        });


        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        chart.set("cursor", am5xy.XYCursor.new(yo.root_grafico, {
          xAxis: xAxis,
          yAxis: yAxis,
          snapToSeries: [series]
        }));

        series.data.setAll(data);
        xAxis.data.setAll(data);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear(1000);
        chart.appear(1000, 100);

      }); // end am5.ready()

      console.log(yo.$refs.chartdiv)
      console.log(yo.root_grafico)



    },

    beforeDestroy() {
      if (this.root) {
        this.root.dispose();
      }
    },

    obtenerHistorialCosechadores(){

      const yo=this
      yo.loading=true
      console.log("OBTENIENDO REGISTROS DE HISTORIAL COSECHADORES")

      // yo.opcioness.xAxisData=[]
      // yo.opcioness.series=[]

      const data = JSON.stringify(
          {
            "fecha_inicio": yo.fecha_inicio,
            "fecha_fin":yo.fecha_fin
          }
      )

      const config={
        method: 'post',
        url: '/cosecha/cosecha/historial_cosechadores/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data:data
      }

      axiosIns(config)
          .then(function(response){
            if(response.status==200){
              console.log("LLENANDO")

              console.log(response.data['promedios'])

              yo.opcioness.xAxisData=[]
              yo.opcioness.series=[]
              // yo.conta++
              console.log(response.data)

              yo.items = response.data['response'];
              yo.totalRows = yo.items.length

              let z=0


              // var a=[]
              // var b=[]

              // for (let x of response.data['xAxisData']){
              //   // a.push(x.toFixed(2))
              //   x=x.toFixed(2)
              //   yo.opcioness.series.push(x)
              // }

              // for (let y of response.data['series']){
              //   // b.push(y)
              //   yo.opcioness.xAxisData.push(y)
              // }

              // yo.opcioness.xAxisData=a
              // yo.opcioness.series=b

              console.log("T")
              console.log(yo.opcioness.series)
              console.log(yo.$refs.graf_lin)

              // yo.$refs.graf_lin.updateChartOptions();

              // -------------- AMCHARTS


              yo.promedios=[]
              yo.promedios=response.data['promedios']
              yo.dibujarGrafico();


            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
            // yo.$nextTick(() => {
            //   yo.$forceUpdate();
            // });

          });

    },

    actualizarEstacion(){
      console.log("ACTUALIZANDO ESTACION")
      const yo=this

      if (yo.estacion ==''){
        yo.loadingEST=false
      }else{
        yo.loadingEST=true
      }

      document.getElementById('n_estacion').innerHTML=this.estacion
    },

    dataInicial(){
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana.toString().padStart(2, '0')
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
      // this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.filter = this.semana
      this.filter_sig = this.semana_sig

    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    handleOkRecepcion(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarRecepcion()
    },

    handleOkEntrega(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarEntrega()
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarRegistro()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },

    asignarInicioFinSemana(){
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52){
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana*7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    autorizar(data){
      this.estado_aprobar = null

      if(data['estado'] === '0'){
        this.modalEditarEstadoShow = true
        this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      }else{
        if(this.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden seleccionar los registro con aprobación pendiente.", 'warning', 6000)
        }else{
          this.modalEditarEstadoShow = true
          this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
        }
      }
    },

    verDetalle(datos){
      console.log(datos)
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos){
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemSgte = true
    },

    descargarPlantilla(){
      const yo = this
      const config = {
        method: 'get',
        url: '/cosecha/fertilizacion/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });
    },

    filtros(){
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
              invoice.semana === (this.semanaFiltro || invoice.semana) &&
              invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
      )
      this.totalRows = this.items.length
    },

    modal_registro(valor){
      console.log("SSSSSSSSSSSSSSSS")
      const yo = this

      console.log(valor)

      if(valor==true){
        yo.modal_registro_entrega=true
      }else{
        yo.modal_registro_devolucion=true
      }

    },


    descargarRegistros(){
      const yo = this

      // const semmm = valor ? yo.semana : yo.semana_sig
      // const datos = yo.items_completo.filter(invoice => invoice.semana === semmm)

      // console.log(datos)
      // yo.loadingSAD = valor
      // yo.loadingSSD = !valor

      yo.loading2=true

      const data = JSON.stringify(
          {
            "datos": yo.items
          }
      )

      const config = {
        method: 'post',
        url: '/cosecha/cosecha/historial_cosechadores/exportarExcel/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "HIST_COSECHADORES_"+ yo.fecha_inicio +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading2=false
          });
    },


    descargarPdf(){
      const yo=this
      yo.loading3=true
      const nombre_archivo='HISTORIAL COSECHADORES '+yo.fecha_inicio.toString()+' AL '+yo.fecha_fin.toString()
      // const nombre_archivo='HISTORIAL COSECHADORES'

      const data=JSON.stringify(
          {
            'datos': yo.items,
          }
      )

      const config={
        method:'post',
        url:'/cosecha/cosecha/historial_cosechadores/exportarPdf/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      }

      axiosIns(config)
          .then(function(response){
            if(response.status===200){
              console.log("RSPTA GOOD")
              var pdf_url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
              // window.open(pdf_url);
              const link = document.createElement('a');
              link.href = pdf_url;
              link.setAttribute('download', nombre_archivo+'.pdf');
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            yo.loading3=false
          });
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: '';
}


.tablaferti{
  min-height: 52vh!important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

.contenedor_estacion{
  position:absolute;
  right:0;
  top: 110px;
  z-index:15;
  font-size:18px;
  font-weight:bold
}

//Para ocultarle el boton de cerrar al modal cuando se aperturael modulo
#modal-seleccionar-estacion .close,
.vs__clear{
  display:none
}

.align-right-modal .modal-dialog {
  position: absolute;
  top:15%;
  right: 5%;
}

.align-left-modal .modal-dialog {
  position: absolute;
  top:15%;
  left: 10%;
}

.custom-modal-style .modal-content {
  background-color: transparent;
  box-shadow: none;
}

.modal-backdrop{
  z-index:0;
  width: 0;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grafico_lineal {
  width: 100%;
  /* height: 410px; */
  height: 536px;
}


/* .ocultador{
  width: 95px;
  height:36px;
  background:#fff;
  position:absolute;
  z-index:100;
  bottom:0;
} */

.contenedor_grafico{
  position:relative
}

</style>
